import ProjectsResource from 'remote/resources/projects';
import OrganizationsResource from 'remote/resources/organizations';

export const setMFA = (tenantId: string, enabled: boolean) =>
  ProjectsResource.setMFA(tenantId, enabled);
const sefOrganizationMFA = (organizationId: string, enabled: boolean) =>
  OrganizationsResource.setMFA(organizationId, enabled);

export default sefOrganizationMFA;
